import { selectAuthGatesSet } from 'productupdates-ui/js/app/auth/AuthSelectors';
import { useAppSelector } from '../../../app/indexReducer';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
function GateWrapper({
  ungatedToAny,
  children,
  fallbackComponent = null
}) {
  const gateSet = useAppSelector(selectAuthGatesSet);
  const isUngatedToAny = ungatedToAny.map(gateName => gateSet.has(gateName)).some(Boolean);
  return isUngatedToAny ? /*#__PURE__*/_jsx(_Fragment, {
    children: children
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: fallbackComponent
  });
}
export default GateWrapper;